module.exports = __webpack_public_path__ + "static/media/notificacoes.739e6143.png";